import { makeStyles } from '@material-ui/styles'

const styles = makeStyles((theme) => ({
  containerMessages: {
    overflowY: 'auto',
    paddingRight: 14,
  },
  gridContainer: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: 'repeat(15, 1fr)',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(12, 1fr)',
    },
  },
  gridItems: {
    gridColumn: 'span 3',
    [theme.breakpoints.down('md')]: {
      gridColumn: 'span 4',
    },
    [theme.breakpoints.down('sm')]: {
      gridColumn: 'span 6',
    },
    [theme.breakpoints.down('xs')]: {
      gridColumn: 'span 12',
    },
  },
  secondLastGridItem: {
    [theme.breakpoints.only('md')]: {
      gridColumn: 'span 6',
    },
    [theme.breakpoints.only('xs')]: {
      gridColumn: '1 / -1',
    },
  },
  lastGridItem: {
    [theme.breakpoints.only('sm')]: {
      gridColumn: '1 / -1',
    },
  },
}))

export default styles
